var _path, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fi-rr-calendar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5293",
    "data-name": "Path 5293",
    d: "M19,2H18V1a1,1,0,0,0-2,0V2H8V1A1,1,0,0,0,6,1V2H5A5.006,5.006,0,0,0,0,7V19a5.006,5.006,0,0,0,5,5H19a5.006,5.006,0,0,0,5-5V7A5.006,5.006,0,0,0,19,2ZM2,7A3,3,0,0,1,5,4H19a3,3,0,0,1,3,3V8H2ZM19,22H5a3,3,0,0,1-3-3V10H22v9A3,3,0,0,1,19,22Z",
    fill: "#536dfe"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_387",
    "data-name": "Ellipse 387",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(10.5 13.5)",
    fill: "#536dfe"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_388",
    "data-name": "Ellipse 388",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(5.5 13.5)",
    fill: "#536dfe"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_389",
    "data-name": "Ellipse 389",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(15.5 13.5)",
    fill: "#536dfe"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCalendar);
export default __webpack_public_path__ + "static/media/blue-calendar.6339dee0.svg";
export { ForwardRef as ReactComponent };